export enum EmailType {
   ENROLLMENT = 'ENROLLMENT',
   PAYMENT_LINK = 'PAYMENT_LINK',
   MISSING_DATA = 'MISSING_DATA',
   MEM_VAL_ACCEPTED = 'MEM_VAL_ACCEPTED',
   SIGN_UP_LINK = 'SIGN_UP_LINK'
}
